import { useSuspense } from "@api";
import type { TCommunicationTemplate } from "@bbj-types/communication";
import type { CommunicationTemplateType, FeatureTemplate } from "@bbj-types/communication/enum";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosCommunication, axiosCommunicationInstance } from "./axios";

export type TGetCommunicationTemplatesFilledQuery = {
  type: CommunicationTemplateType[];
  feature: FeatureTemplate;
  candidateId: ObjectId;
  offerId?: ObjectId;
  workshopId?: ObjectId;
};

export type TGetCommunicationTemplatesFilled = Pick<
  TCommunicationTemplate,
  "_id" | "content" | "name" | "subject" | "type" | "organisation"
>[];

export const useGetCommunicationTemplatesFilled = () => {
  const [state, execute, cancel] = axiosCommunication<TGetCommunicationTemplatesFilled, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query: TGetCommunicationTemplatesFilledQuery) => {
      return execute({
        url: "/templates/filled",
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetCommunicationTemplatesFilledSuspense = (query: TGetCommunicationTemplatesFilledQuery) => {
  return useSuspense(
    () =>
      axiosCommunicationInstance.get<TGetCommunicationTemplatesFilled>("/templates/filled", {
        withCredentials: true,
        params: query,
      }),
    []
  );
};
